import type { Component } from 'vue'
import type { GQLSlice } from './generated/slices'
import PortableText from '@core/components/portable-text/index.vue'

const ArticleTitleSlice = defineAsyncComponent<Component>(async () => import('./slices/article-title/article-title.vue')) // prettier-ignore
const BreadcrumbSlice = defineAsyncComponent<Component>(async () => import('./slices/breadcrumb/breadcrumb.vue')) // prettier-ignore
const CollapsableTextSlice = defineAsyncComponent<Component>(async () => import('./slices/collapsable-text/collapsable-text.vue')) // prettier-ignore
const BestProvidersForSlice = defineAsyncComponent<Component>(async () => import('./slices/best-providers-for/best-providers-for.vue')) // prettier-ignore
const CorridorsListSlice = defineAsyncComponent<Component>(async () => import('./slices/corridors-list/corridors-list.vue')) // prettier-ignore
const CountriesCorridorsListSlice = defineAsyncComponent<Component>(async () => import('./slices/countries-corridors-list/countries-corridors-list.vue')) // prettier-ignore
const EmbeddedSlice = defineAsyncComponent<Component>(async () => import('./slices/embedded/embedded.vue')) // prettier-ignore
const FaqSlice = defineAsyncComponent<Component>(async () => import('./slices/faq/faq.vue')) // prettier-ignore
const HighlightBoxSlice = defineAsyncComponent<Component>(async () => import('./slices/highlight-box/highlight-box.vue')) // prettier-ignore
const HowToStepsSlice = defineAsyncComponent<Component>(async () => import('./slices/how-to-steps/how-to-steps.vue')) // prettier-ignore
const RelatedContentSlice = defineAsyncComponent<Component>(async () => import('./slices/related-content/related-content.vue')) // prettier-ignore
const CtaSlice = defineAsyncComponent<Component>(async () => import('./slices/simple-cta/simple-cta.vue')) // prettier-ignore
const StickyCtaSlice = defineAsyncComponent<Component>(async () => import('./slices/sticky-cta/sticky-cta.vue')) // prettier-ignore
const TableGsheetSlice = defineAsyncComponent<Component>(async () => import('./slices/table-gsheet/table-gsheet.vue')) // prettier-ignore
const TableOfContentsSlice = defineAsyncComponent<Component>(async () => import('./slices/table-of-contents/table-of-contents.vue')) // prettier-ignore
const TransferSearchFormSlice = defineAsyncComponent<Component>(async () => import('./slices/transfer-search-form/transfer-search-form.vue')) // prettier-ignore
const TextImageSlice = defineAsyncComponent<Component>(async () => import('./slices/text-image/text-image.vue')) // prettier-ignore
const HeroSearchFormSlice = defineAsyncComponent<Component>(async () => import('./slices/hero-search-form/hero-search-form.vue')) // prettier-ignore
const CalloutSlice = defineAsyncComponent<Component>(async () => import('./slices/callout/callout.vue')) // prettier-ignore
const ChecklistSlice = defineAsyncComponent<Component>(async () => import('./slices/checklist/checklist.vue') ) // prettier-ignore
const TextBlocksSlice = defineAsyncComponent<Component>(async () => import('./slices/text-blocks/text-blocks.vue')) // prettier-ignore
const TestimonialsSlice = defineAsyncComponent<Component>(async () => import('./slices/testimonials/testimonials-list.vue')) // prettier-ignore
const ProvidersExchangeRatesSlice = defineAsyncComponent<Component>(async () => import('./slices/providers-exchange-rates/providers-exchange-rates.vue')) // prettier-ignore
const CurrencyTableSlice = defineAsyncComponent<Component>(async () => import('./slices/currency-table/currency-table.vue')) // prettier-ignore
const HeroExchangeRateSlice = defineAsyncComponent<Component>(async () => import('./slices/hero-exchange-rate/hero-exchange-rate.vue')) // prettier-ignore
const AboutExchangeRatesSlice = defineAsyncComponent<Component>(async () => import('./slices/about-exchange-rates/about-exchange-rates.vue')) // prettier-ignore
const CorridorEmailAlertSlice = defineAsyncComponent<Component>(async () => import('./slices/corridor-email-alert/corridor-email-alert.vue')) // prettier-ignore
const ProviderVsProviderSlice = defineAsyncComponent<Component>(async () => import('./slices/provider-vs-provider/provider-vs-provider.vue')) // prettier-ignore
const HeroProviderVsProviderSlice = defineAsyncComponent<Component>(async () => import('./slices/hero-provider-vs-provider/hero-provider-vs-provider.vue')) // prettier-ignore
const ProvidersCountryAvailabilitySlice = defineAsyncComponent<Component>(async () => import('./slices/providers-country-availability/providers-country-availability.vue')) // prettier-ignore
const PartnerPromoSlice = defineAsyncComponent<Component>(async () => import('./slices/partner-promo/partner-promo.vue')) // prettier-ignore
const LinkGridSlice = defineAsyncComponent<Component>(async () => import('./slices/link-grid/link-grid.vue')) // prettier-ignore
const TopupOperatorCardsSlice = defineAsyncComponent<Component>(async () => import('./slices/topup-operator-cards/topup-operator-cards.vue')) // prettier-ignore
const TopupProductsSlice = defineAsyncComponent<Component>(async () => import('./slices/topup-products/topup-products.vue')) // prettier-ignore
const HeroTopupSlice = defineAsyncComponent<Component>(async () => import('./slices/hero-topup/hero-topup.vue')) // prettier-ignore
const TopupCalloutSlice = defineAsyncComponent<Component>(async () => import('./slices/topup-callout/topup-callout.vue')) // prettier-ignore
const CountriesTopupOperatorsListSlice = defineAsyncComponent<Component>(async () => import('./slices/countries-topup-operators-list/countries-topup-operators-list.vue')) // prettier-ignore
const VerticalAgnosticComparisonSlice = defineAsyncComponent<Component>(async () => import('./slices/vertical-agnostic-comparison/vertical-agnostic-comparison.vue')) // prettier-ignore
const TopProvidersSlice = defineAsyncComponent<Component>(async () => import('./slices/top-providers/top-providers.vue')) // prettier-ignore
const KeyFactsSlice = defineAsyncComponent<Component>(async () =>  import('./slices/key-facts/key-facts.vue')) // prettier-ignore
const SpotlightedProviderSlice = defineAsyncComponent<Component>(async () => import('./slices/spotlighted-provider/spotlighted-provider.vue')) // prettier-ignore
const LeadCaptureSlice = defineAsyncComponent<Component>(async () => import('./slices/lead-capture/lead-capture.vue')) // prettier-ignore
const VideoSlice = defineAsyncComponent<Component>(async () => import('./slices/video/video.vue')) // prettier-ignore
const EntitiesScoresSlice = defineAsyncComponent<Component>(async () => import('./slices/entities-scores/entities-scores.vue') ) // prettier-ignore
const EntityScoreCategoryDetailSlice = defineAsyncComponent<Component>(async () => import('./slices/entity-score-category-detail/entity-score-category-detail.vue') ) // prettier-ignore
const EntityScoreSummarySlice = defineAsyncComponent<Component>(async () => import('./slices/entity-score-summary/entity-score-summary.vue') ) // prettier-ignore
const ProsAndConsSlice = defineAsyncComponent<Component>(async () => import('./slices/pros-and-cons/pros-and-cons.vue')) // prettier-ignore
const EsimSearchFormSlice = defineAsyncComponent<Component>(async () => import('./slices/esim-search-form/esim-search-form.vue')) // prettier-ignore
const HandPickedEsimsSlice = defineAsyncComponent<Component>(async () => import('./slices/hand-picked-esims/hand-picked-esims.vue')) // prettier-ignore
const EsimProvidersListSlice = defineAsyncComponent<Component>(async () => import('./slices/esim-providers-list/esim-providers-list.vue')) // prettier-ignore

export function isDefinedSlice(slice: GQLSlice | null) {
  return slice?._type && slices[slice._type] !== undefined
}

export const slices: Partial<Record<GQLSlice['_type'], Component | null>> = {
  AnchorSlice: null,
  ExperimentSlice: null,
  BoxBreakSlice: null,
  Block: PortableText,
  Image: PortableText,
  ArticleTitleSlice,
  BreadcrumbSlice,
  CollapsableTextSlice,
  CurrencyTableSlice,
  BestProvidersForSlice,
  CorridorsListSlice,
  CountriesCorridorsListSlice,
  EmbeddedSlice,
  FaqSlice,
  HighlightBoxSlice,
  HowToStepsSlice,
  RelatedContentSlice,
  TopupProductsSlice,
  CtaSlice,
  StickyCtaSlice,
  ProvidersExchangeRatesSlice,
  TableGsheetSlice,
  TableOfContentsSlice,
  TransferSearchFormSlice,
  TextImageSlice,
  HeroSearchFormSlice,
  TestimonialsSlice,
  CalloutSlice,
  ChecklistSlice,
  TextBlocksSlice,
  HeroExchangeRateSlice,
  AboutExchangeRatesSlice,
  CorridorEmailAlertSlice,
  ProviderVsProviderSlice,
  HeroProviderVsProviderSlice,
  ProvidersCountryAvailabilitySlice,
  EntityScoreSummarySlice,
  EntitiesScoresSlice,
  EntityScoreCategoryDetailSlice,
  PartnerPromoSlice,
  LinkGridSlice,
  TopupOperatorCardsSlice,
  HeroTopupSlice,
  TopupCalloutSlice,
  CountriesTopupOperatorsListSlice,
  VerticalAgnosticComparisonSlice,
  TopProvidersSlice,
  SpotlightedProviderSlice,
  LeadCaptureSlice,
  KeyFactsSlice,
  VideoSlice,
  EsimSearchFormSlice,
  ProsAndConsSlice,
  HandPickedEsimsSlice,
  EsimProvidersListSlice,
}
